var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-bar"}},[_c('v-app-bar',[_c('v-img',{attrs:{"src":require("../assets/img/logo.png"),"max-width":"250"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }